import { defineStore } from 'pinia'

interface GlobalsState {
  localStorage: { [key: PropertyKey]: unknown }
  sessionStorage: { [key: PropertyKey]: unknown }
  history: {
    entries: {
      state: unknown
      title: string
      url: string | null
    }[]
    currentIndex: number
  }
  cookie: string
  authToken: string | null
  ati: string | null
}

export const useGlobals = defineStore('global', {
  state: (): GlobalsState => {
    return {
      localStorage: {},
      sessionStorage: {},
      history: {
        entries: [],
        currentIndex: -1,
      },
      cookie: '',
      authToken: null,
      ati: null,
    }
  },
})
